import { useToast } from '@chakra-ui/toast';
import React, { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { StoreState } from '../../types/state';

function Notifications(props: ReduxProps) {
  let { message, type, id } = props;

  const toast = useToast();
  useEffect(() => {
    if (message && type && id) {
      if (!toast.isActive(id)) {
        toast({
          title: message,
          status: type as any,
          position: 'top-right',
          isClosable: true,
        });
      }
    }
  }, [id, message, toast, type]);

  // switch (type) {
  //     case 'info':
  //         toast.info(message, { position: toast.POSITION.TOP_RIGHT });
  //         break;
  //     case 'success':
  //         toast.success(message, { position: toast.POSITION.TOP_RIGHT });
  //         break;
  //     case 'warning':
  //         toast.warning(message, { position: toast.POSITION.TOP_RIGHT });
  //         break;
  //     case 'error':
  //         toast.error(message, { position: toast.POSITION.TOP_RIGHT });
  //         break;
  //     default:
  //         break
  // }

  return null;
}
const mapStateToProps = (state: StoreState) => ({
  message: state.notification?.message,
  type: state.notification?.type,
  id: state.notification?.id,
});

const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(React.memo(Notifications));
